<template>
    <div>
        <b-modal id="create-contact" size="lg" title="İletişim Bilgisi Ekle" no-close-on-esc no-close-on-backdrop>
            <firm-create-or-update-contact v-model="contact" :dummy-location="true"  :communication-languages="communicationLanguages" :occupation-titles="occupationTitles" :firm-contact-types="firmContactTypes"   :locations="locations"></firm-create-or-update-contact>
            <template #modal-footer>
                <button class="btn btn-primary" v-on:click="createContact">Kaydet</button>
            </template>
        </b-modal>
        <v-table    ref="table"
                    :add-callback="createNew"
                    with-items
                    :items="value"
                    name="firm-contact"
                    :settings="false"
                    :fields="fields"
                    :buttons="buttons"></v-table>
    </div>
</template>

<script>
import SystemDataApi from '@/api/system-data'
import FirmCreateOrUpdateContact from '@/views/firm-operations/firm/components/FirmCreateOrUpdateContact'
import { BFormCheckbox } from 'bootstrap-vue'

export default {
    components:{
        FirmCreateOrUpdateContact,
        BFormCheckbox
    },
    props:{
        value:Array,
        locations:Array
    },
    data(){
        return{
            buttons:[
                { text:"Sil",key:"delete",icon:"TrashIcon",variant:"danger",action:(item,key,index)=>{ this.$delete(this.value,index) } },
            ],
            fields:[
                {name:"İsim",key:"FirstName"},
                {name:"Soyisim",key:"LastName"},
                {name:"E-Posta",key:"Email"},
                {name:"Cep Telefonu",key:"MobilePhone"},
                {name:"Telefon",key:"Phone"},
                {name:"Dahili Numara",key:"InternalNumber"},
                {name:"Unvan",key:"OccupationTitle.Name"},
                {name:"Lokasyon",key:"FirmLocationDummy.LocationName"},
                {name:"Muhasebe Sorumlusu",key:"AccountingManager"},
                {name:"Finansman Sorumlusu",key:"FinanceOfficer"},
                {name:"Teklif Sorumlusu",key:"OfferOfficer"},
                {name:"Operasyon Sorumlusu",key:"OperationsManager"},
                {name:"Satın Alma Sorumlusu",key:"PurchasingManager"},
            ],
            communicationLanguages:[],
            occupationTitles:[],
            firmContactTypes:[],
            contact:{
                FirmLocationDummy:null,
                FirmLocationDummyId:null,
                CommunicationLanguage:null,
                CommunicationLanguageId:null,
                Email:null,
                MobilePhone:null,
                Phone:null,
                InternalNumber:null,
                OperationsManager:false,
                AccountingManager:false,
                PurchasingManager:false,
                FinanceOfficer:false,
                OfferOfficer:false,
                ContactType:null,
                ContactTypeId:null,
                FirstName:null,
                LastName:null,
                OccupationTitle:null,
                OccupationTitleId:null
            }
        }
    },
    mounted(){
        this.getCommunicationLanguages()
        this.getOccupationTitles()
    },
    methods:{
        clearForm(){
            this.contact.FirmLocationDummy=null
            this.contact.FirmLocationDummyId=null
            this.contact.CommunicationLanguage=null
            this.contact.CommunicationLanguageId="11e1ec79-dc35-41b3-8a5a-5eaeaf0848cc"/*DEFAULT TR*/
            this.contact.MobilePhone=null
            this.contact.InternalNumber=null
            this.contact.Phone=null
            this.contact.Email=null
            this.contact.OperationsManager=false
            this.contact.AccountingManager=false
            this.contact.PurchasingManager=false
            this.contact.FinanceOfficer=false
            this.contact.OfferOfficer=false
            this.contact.ContactType=null
            this.contact.ContactTypeId=null
            this.contact.FirstName=null
            this.contact.LastName=null
            this.contact.OccupationTitle=null
            this.contact.OccupationTitleId=null
        },
        createNew(){
            this.clearForm()
            this.$showModal("create-contact")
        },
        createContact(){
            this.value.push(structuredClone(this.contact))
            this.$hideModal("create-contact")
        },
        getCommunicationLanguages(){
            SystemDataApi.CommunicationLanguage().then(res=>{
                this.communicationLanguages = res.data.Data
            })
        },
        getOccupationTitles(){
            SystemDataApi.OccupationTitle().then(res=>{
                this.occupationTitles = res.data.Data
            })
        }
    }
}
</script>

<style>

</style>